"use client";

import { c as _c } from "react/compiler-runtime";
import { Container, SectionSubHeading, SectionTitle, LegalCard, AppButton } from "@/components";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import { termsData } from "@/data/TermsData";
const TermsOfUseView = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SectionSubHeading subtitle="Terms of Use" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-16 space-y-4 max-w-3xl"><div className="space-y-2">{t0}<SectionTitle as="h1" title={<>Terms of Service <br /><span className="text-primary">{"& Conditions"}</span></>} className="font-black leading-[1.1]" /></div><p className="text-lg text-muted-foreground leading-relaxed">Please read these terms carefully before using our services. By accessing Octarnal's platforms, you agree to be bound by these digital guidelines.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-1 md:grid-cols-12 lg:gap-6 gap-4">{termsData.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      scale: 0.95
    };
    t4 = {
      opacity: 1,
      scale: 1
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex h-12 w-12 items-center justify-center rounded-full shrink-0 bg-primary text-white"><CheckCircle2 size={24} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="lg:py-16 py-8"><Container className="px-4 lg:px-10">{t1}{t2}<motion.div initial={t3} whileInView={t4} className="mt-16 flex flex-col lg:items-center items-end lg:justify-between justify-start gap-6 rounded-2xl bg-primary-foreground p-8 lg:flex-row md:p-10 border-2 border-primary/20"><div className="flex flex-col md:flex-row md:items-center gap-4">{t5}<div className="space-y-1"><h4 className="text-lg font-bold text-black">Acceptance of Terms</h4><p className="text-sm text-muted-foreground">By using our services, you acknowledge that you have read and understood these terms.</p></div></div><AppButton buttonClass="h-12 px-8" shadowClass="bg-black">I Agree to Terms</AppButton></motion.div><div className="mt-12 text-center text-xs font-medium uppercase tracking-widest text-muted-foreground/60">Last Updated: March 19, 2026 • Octarnal Legal Department</div></Container></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default TermsOfUseView;
function _temp(item, index) {
  return <LegalCard key={index} title={item.title} description={item.description} icon={item.icon} className={item.span} delay={index * 0.1} />;
}